import React from 'react';
import { Button } from './ui/button';
import { MessageCircle } from 'lucide-react';
import { openTawktrikChat } from '../utils/chatUtils';

const LPHeader = ({ onOpenModal }) => {
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-4">
        <div className="flex items-center justify-between gap-2">
          {/* Logo - Responsive sizing */}
          <div className="flex items-center flex-shrink-0">
            <img 
              src="/assets/img/brand/logo-dark.png" 
              alt="Trademark Essential Logo" 
              className="h-8 md:h-10 w-auto"
            />
          </div>

          {/* Buttons - Responsive */}
          <div className="flex items-center gap-2">
            {/* Register Button - Responsive text */}
            <Button
              onClick={() => onOpenModal && onOpenModal('Register My Trademark - Header')}
              className="bg-[#FFB400] hover:bg-[#e5a200] text-[#2B0A12] font-semibold text-xs sm:text-sm md:text-base px-2 sm:px-4 md:px-6 py-1.5 md:py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 whitespace-nowrap"
            >
              <span className="hidden sm:inline">Register My Trademark</span>
              <span className="sm:hidden">Register</span>
            </Button>
            
            {/* Chat Button - Hidden on mobile, visible on desktop */}
            <Button
              onClick={openTawktrikChat}
              variant="outline"
              className="hidden lg:flex border-2 border-[#D72638] text-[#D72638] hover:bg-[#D72638] hover:text-white font-semibold px-6 py-2 rounded-lg transition-all duration-300 items-center space-x-2"
            >
              <MessageCircle className="h-4 w-4" />
              <span>Chat Now</span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default LPHeader;
